import React, { useContext, useEffect, useState } from 'react';
import { Badge, Button, Container, Image } from "react-bootstrap"
import { Link } from "react-router-dom"
import FavoriteIcon from "../FavoriteIcon"
import * as Icon from 'react-bootstrap-icons';
import ApiFetch from "../ApiFetch";
import FollowButton from '../FollowButton';
import UserInfoPopup from './UserInfoPopup';
import { useTranslation } from "react-i18next";
import { Chip, Tooltip } from '@mui/material';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';
import Thumb from './Thumb';
import { LoginInfo } from '../../App';
import CommonDialog from './CommonDialog';

const TileAIGenerate = (props) => {
    async function getUserInfo(userIdOrDisplayId){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/profile/"+userIdOrDisplayId)
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    const {t,i18n} = useTranslation()
    let data = props.data
    let i = props.i
    let dialog = props.dialog
    let observer = props.observer
    useEffect(() => {
        document.querySelectorAll(".lazy").forEach(e => {
            if(e.dataset.lazy !== "1"){
                observer.observe(e)
                e.dataset.lazy = "1"
            }
        })
    })
    const [previewSource,setPreviewSource] = useState("")
    const [previewFlg,setPreviewFlg] = useState(false)
    const [showGeneratedInfo,setShowGeneratedInfo] = useState(false)
    const random = Math.random() * 100000
    function path(data,isSrc){
        if(data.mode === "txt2img"){
            return ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/'+data.mode+'/'+(data.proc_id)+ApiFetch.API_THUMB_EXT
        } else if(data.mode === "img2img" && !isSrc) {
            return ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/'+data.mode+'/'+(data.proc_id)+ApiFetch.API_THUMB_EXT
        } else if(data.mode === "img2img" && isSrc) {
            return ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/'+data.mode+'_src/'+(data.proc_id)+".png"
        }
    }
    return (
<Container style={{position:"relative",width:"100%"}} className="event-card mb-0 p-0"
    onMouseOver={() => {
        let elm = document.getElementById("thumb-"+i)
        elm.style.opacity = "1"
        elm.style.transition = "0.1s"
    }}
    onMouseLeave={() => {
        let elm = document.getElementById("thumb-"+i)
        elm.style.opacity = "0"
        elm.style.transition = "0.1s"
    }}
>
    {previewFlg ? (
    <div style={{position:"fixed",top:0,left:0,width:"100%",height:"100%",zIndex:4,cursor:"pointer"}} onClick={() => setPreviewFlg(false) }>
        <div style={{position:"fixed",top:0,left:0,backgroundColor:"#000000",width:"100%",height:"100%",opacity:0.9}} />
        <Image
            src={previewSource}
            id="preview"
            style={{position:"fixed",objectFit:"contain",width:"100%",height:"100%"}}
        />
    </div>
    ) : ""}
    <div style={{position:"relative",padding:0,overflow:"hidden",cursor:"pointer",border:data.status === 8 || data.status === 9 ? "3px solid red" : "none"}}>
        <Image data-no={i} loading="lazy" src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/getImageSource/"+data.proc_id+"/1/0"} style={{objectFit:"cover",width:"100%",borderRadius:"10px"}} className="p-1 lazy" />
        <Container id={"thumb-"+i} className="p-0" style={{opacity:0}}>
            <Badge bg="secondary" style={{position:"absolute",zIndex:3,bottom:"20px",left:"10px"}}>
                <a href={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+'/'+data.mode+'/'+(data.proc_id)+".png"} download>
                    <Icon.CloudDownloadFill style={{fontSize:"24px",color:"#EEEEEE"}} onClick={(e) => e.stopPropagation()} />
                </a>
            </Badge>
            <Container style={{position:"absolute",zIndex:3,bottom:"60px",left:"0px",whiteSpace:"nowrap",overflow:"hidden"}}>
                <Link to={"/user/"+(data.user_id)} style={{color:"#FFFFFF",fontWeight:"bold",textDecoration:"none",cursor:"pointer",display:"block"}}>
                    <Image id={"thumb-"+i} loading="lazy" src={ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/profile/'+(data.user_id)+'_s.jpg?'+data.hash} style={{borderRadius:"12px",display:data.user_id ? "inline" : "none"}} width="24px" height="24px" />
                    {data.user_name}
                </Link>
            </Container>
            <Container style={{fontSize:"14px",position:"absolute",zIndex:3,bottom:"26px",left:"40px",whiteSpace:"nowrap",overflow:"hidden",color:"#FFFFFF"}}>
                {data.create_datetime}
            </Container>
            <Container style={{position:"absolute",top:0,backgroundColor:"#000000",opacity:0.5,width:"100%",height:"100%",zIndex:2}}
                onClick={(e) => {
                    setPreviewSource(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/getImageSource/"+data.proc_id+"/1/0")
                    setPreviewFlg(true)
                }}
            />
            <Container style={{position:"absolute",top:"10px",right:0,color:"#FFFFFF",fontWeight:"bold",fontSize:"15px",whiteSpace:"nowrap",overflow:"hidden",zIndex:2}}>
                {showGeneratedInfo ? <CommonDialog open={showGeneratedInfo} onClose={() => setShowGeneratedInfo(false)} content={
                    <>
                        <div className='text-center m-2 d-flex flex-wrap'>
                        {[...Array(data.count)].map((d,i) => {
                            let extNo = i === 0 ? "" : "-"+(i+1)
                            return (
                                <div style={{
                                    position: 'relative', 
                                    width: data.count > 1 ? '50%' : '100%'
                                }}>
                                    {data.count > 1 ? (
                                    <Chip label={i+1} color='primary' style={{
                                        position: 'absolute',
                                        top: '5px',
                                        left: '5px',
                                        padding: '2px 6px',
                                        borderRadius: '3px',
                                        zIndex: 1
                                    }} />
                                    ) : ""}
                                    <Image
                                        width="100%"
                                        src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/getImageSource/"+data.proc_id+"/1/"+i}
                                    />
                                </div>
                            )
                        })}
                        </div>
                        <Container>
                            {data.create_datetime}<br />
                            prompt:<br />{data.prompt}<br /><br />
                            negative prompt:<br />{data.negative_prompt}<br /><br />
                            steps: {data.steps} scale: {data.cfg_scale} denoising_strength: {data.denoising_strength} seed: {data.real_seed === "" ? data.seed : data.real_seed}<br />
                            sampler: {data.sampler}<br />
                            Hires.fix: {data.enable_hr === 1 ? "Yes" : "No"}<br />
                            Hires Upscaler: {data.enable_hr === 1 ? data.hr_upscaler : ""}<br />
                            resolution: {(data.enable_hr === 1 ? data.width * parseInt(data.hr_scale) : data.width) * (data.extra === 1 && data.mode !== "extraBatchImages" ? 2 : 1)}x{(data.enable_hr === 1 ? data.height * parseInt(data.hr_scale) : data.height) * (data.extra === 1 && data.mode !== "extraBatchImages" ? 2 : 1)}<br />
                            mode: {data.mode === "extraBatchImages" ? "画像拡大" : data.mode}<br />
                            model: {data?.model_name || data.sd_model_checkpoint}<br />
                            VAE: {data.sd_vae}<br />
                            inpaint: {data.inpaint === 1 ? "Yes" : "No"}<br />
                            画像拡大: {data.extra === 1 ? "Yes" : "No"}<br />
                            彩色: {data.controlnet_module === 'lineart_anime_denoise' ? "Yes" : "No"}<br />
                            フル版: {data.full === 1 ? "Yes" : "No"}<br />
                            server: {data.server_id}
                            <Container className='text-center'>
                                <Tooltip title="共有リンクをコピーします。" arrow>
                                <Button
                                    variant='outlined' className='m-1 p-1' onClick={() => {
                                    createShareId(data.proc_id).then(r => {
                                        if(r.result){
                                            navigator.clipboard.writeText("https://ourt-ai.work/upload/image/generate?sid="+r.data.share_id)
                                            dialog(t("common.info"),"共有リンクをクリップボードにコピーしました。")
                                        } else {
                                            dialog(t("common.error"),r.errors)
                                        }
                                        setShowGeneratedInfo(false)
                                    })
                                }}><Icon.Share /></Button>
                                </Tooltip>
                                <br />
                                {loginInfo.plan != "" || data.use_coin > 0 ? (<>
                                {[...Array(data.count)].map((d,i) => {
                                    let label = data.count === 1 ? ""  : ""+(i+1)
                                    let extNo = i === 0 ? ""  : "-"+(i+1)
                                    return <Chip bg="secondary" className='m-1' label={
                                        <a href={ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/getImageSource/"+data.proc_id+"/3/"+i} download={"ourtai_"+data.proc_id+"_"+(i+1)+".png"} style={{textDecoration:"none",display:"block"}}>
                                            <Icon.CloudDownloadFill style={{fontSize:"24px"}} onClick={(e) => e.stopPropagation()} /> PNG{label}
                                        </a>} />
                                })}
                                </>) : (<>
                                    {[...Array(data.count)].map((d,i) => {
                                    let label = data.count === 1 ? ""  : ""+(i+1)
                                    return <Tooltip title="サブスクプランに加入してPNGファイルをダウンロード" arrow><Chip bg="secondary" className='m-1' label={
                                            <Link to={"/legal"} style={{color:"#CCCCCC"}}><Icon.CloudDownloadFill style={{fontSize:"24px"}} /> PNG{label}</Link>
                                        } /></Tooltip>
                                    })}
                                </>)}

                                {[...Array(data.count)].map((d,i) => {
                                    let label = data.count === 1 ? ""  : ""+(i+1)
                                    let extNo = i === 0 ? ""  : "-"+(i+1)
                                    return <Chip bg="secondary" className='m-1' label={
                                        <a href={ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/getImageSource/"+data.proc_id+"/0/"+i} download={"ourtai_"+data.proc_id+"_"+(i+1)+".jpg"} style={{textDecoration:"none",display:"block"}}>
                                            <Icon.CloudDownloadFill style={{fontSize:"24px"}} onClick={(e) => e.stopPropagation()} /> JPG{label}
                                        </a>} />
                                })}
                            </Container>
                            {data.src_group_id !== undefined && data.src_group_id !== "" ? <Container>
                                <p style={{fontWeight:"bold",borderBottom:"3px solid #555555"}}>参考元の作品</p>
                                <Thumb data={{group_id:data.src_group_id,id:data.src_detail_id,favorite:data.src_favorite}} dialog={dialog} />{data.src_title}
                            </Container>
                            : ""}
                            {data.mode !== undefined && data.mode === "img2img" ? <Container>
                                <p style={{fontWeight:"bold",borderBottom:"3px solid #555555"}}>参考画像</p>
                                <img width={"100%"} src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+'/'+data.mode+'_src/'+(data.proc_id)+".png"} />
                            </Container>
                            : ""}
                        </Container>
                    </>
                } fullScreen={false} /> : ""}

                <Icon.InfoCircle style={{fontSize:"20px",cursor:"pointer"}}
                    onClick={() => {
                        setShowGeneratedInfo(true)
                }} />
                {data.count > 1 ? <>&nbsp;<Icon.Images style={{fontSize:"24px",color:"#EEEEEE"}} /></> : ""}
            </Container>
        </Container>
    </div>
</Container>
    )
}
export default TileAIGenerate